import { Card } from 'antd'
import React from 'react'

import { PostType, RequestedUserTimelineEventFragment } from '@/generated/graphql'
import { PostCardActionHover } from '@/modules/post/post-card'
import { PostComments } from '@/modules/post/post-card/post-comments'
import { PostCardContent } from '@/modules/post/post-card/post-contents/post-card-contents.component'
import { PostPerformance } from '@/modules/post/post-card/post-performance/post-performance.component'
import { routes } from '@/routes'

import { ContentModeContext } from './user-timeline-context'
import s from './user-timeline.module.less'

export interface UserTimelineItemProps {
  event: RequestedUserTimelineEventFragment
  showSimplified?: boolean
}

export const TimelineItemCard: React.FC<UserTimelineItemProps & { isSimplified?: boolean }> = ({
  event,
  isSimplified = false,
}) => {
  const [showCreateComment, setShowCreateComment] = React.useState(false)
  const [showMoreComment, setShowMoreComment] = React.useState(false)
  const [loadAndShowComment, setLoadAndShowComment] = React.useState(false)

  if (event?.entity?.__typename !== 'Post') {
    return null
  }

  const post = event.entity!
  const isHonor = post.postType === PostType.Honor

  return (
    <Card className={isHonor && s.honoredBorder}>
      <PostCardActionHover
        post={post}
        setShowCreateComment={setShowCreateComment}
        setShowMoreComment={setShowMoreComment}
      >
        <div
          className={s.postContent}
          onClick={() => window.open(routes.posts.page(post.postId), '_blank', 'noreferrer,noopener')}
        >
          <ContentModeContext.Provider value={{ isSimplified, wordLength: isSimplified ? 30 : undefined }}>
            <PostCardContent
              post={post}
              isGroup={false}
              isUser={true}
              isSection={false}
              isTimeline={true}
              isSinglePost={false}
              isRecommended={false}
            />
          </ContentModeContext.Provider>
        </div>
      </PostCardActionHover>
      {!isSimplified && (
        <div className={s.postPerformance}>
          <PostPerformance
            onClickComment={() => (setShowCreateComment(true), setLoadAndShowComment(true))}
            post={post}
            showReadCount={false}
          />
        </div>
      )}
      {!isSimplified && (
        <PostComments
          post={post}
          showCreateComment={showCreateComment}
          showMoreComment={showMoreComment}
          loadAndShowComment={loadAndShowComment}
          isCommentControllable={false}
          parentCommentPagination={{ last: 2 }}
          childCommentPagination={{ last: 2 }}
        />
      )}
    </Card>
  )
}
